import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  forwardRef,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-toggleable-option',
  imports: [NgClass],
  templateUrl: './toggleable-option.html',
  styleUrl: './toggleable-option.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleableOption),
      multi: true,
    },
  ],
})
export class ToggleableOption implements ControlValueAccessor {
  protected readonly value = signal(false);
  protected readonly isDisabled = signal(false);

  private onChange: (value: boolean) => void = () => {
    console.log('ToggleableOption: onChange not registered');
  };
  private onTouched: () => void = () => {
    console.log('ToggleableOption: onTouched not registered');
  };

  toggle(): void {
    if (this.isDisabled()) return;
    const next = !this.value();
    this.value.set(next);
    this.onChange(next);
    this.onTouched();
  }

  // ControlValueAccessor
  writeValue(value: boolean): void {
    this.value.set(!!value);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }
}
